module.exports = __webpack_public_path__ + "img/banco-desio-no-bg.23599e24.png";